import EquipmentPassportСomparisonView from '@/pages/Equipment/components/Passport/EquipmentPassportСomparisonView'
import { IEquipmentPassport } from '@/pages/Equipment/equipment.types'
import AlertBlock from '@/services/alerts/components/AlertBlock'
import { useRef } from 'react'
import css from '../equipmentViewingStepsContent.module.css'
import EquipmentPassportTree from '../../EquipmentFormFields/EquipmentPassportTree'
import { TEquipmentPassportDifferences } from '../hooks/usePassportDifferences'
import useEquipmentPassportTreeCtrl from '@/pages/Equipment/pages/LiftPage/components/LiftPagePassportContent/hooks/useEquipmentPassportTreeCtrl'
import useChangedPassportGroup from '../hooks/useChangedPassportGroup'
import formatUtils from '@/utils/format.utils'

interface IProps {
  passportDifferences: TEquipmentPassportDifferences
  passportId: IEquipmentPassport['id']
  changedPassportSchemaFieldIds: IEquipmentPassport['id'][]
}

const EquipmentPassportViewingStep = (props: IProps) => {
  const tableRef = useRef<HTMLDivElement>(null)
  const equipmentPassportTreeCtrl = useEquipmentPassportTreeCtrl({
    treeKey: '/equipment/lifts/edit/viewingStep',
    tableRef,
  })

  const changedGroups = useChangedPassportGroup({
    passportSchemaId: props.passportId,
    changedPassportSchemaFieldIds: props.changedPassportSchemaFieldIds,
  })

  const renderAlerBlock = () => {
    const changedPassportValuesNum = props.changedPassportSchemaFieldIds.length
    const text = [
      formatUtils.numWord(changedPassportValuesNum, ['Отредактирован', 'Отредактировано', 'Отредактировано']),
      changedPassportValuesNum,
      formatUtils.numWord(changedPassportValuesNum, ['параметр', 'параметра', 'параметров']),
    ]

    return <AlertBlock type="warning" title={`Проверьте корректность выполненных изменений. ${text.join(' ')}:`} />
  }

  return (
    <div className="flex-lines gap16 height100" style={{ minHeight: 0 }}>
      <div style={{ paddingRight: '24px' }}>{renderAlerBlock()}</div>
      <div className="inline-flex-gap gap24" style={{ overflow: 'auto', flex: '1 1 0%', paddingRight: '18px' }}>
        <div className={css.passportNavBlock}>
          <EquipmentPassportTree
            selectCtrl={equipmentPassportTreeCtrl.groupSelectCtrl}
            passportSchemaId={props.passportId}
            handleSelect={equipmentPassportTreeCtrl.handleGroupSelect}
            visibleGroups={changedGroups.map((item) => item.id)}
          />
        </div>
        <EquipmentPassportСomparisonView
          passportDifferences={props.passportDifferences}
          passportSchemaId={props.passportId}
          ref={tableRef}
          onGroupIntoViewportChange={equipmentPassportTreeCtrl.onGroupIntoViewportChange}
          changedGroups={changedGroups}
          isChangedOnly={true}
        />
      </div>
    </div>
  )
}

export default EquipmentPassportViewingStep
